// src/pages/private/settings/securityTabs/AccountDeletion.jsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import HoldToConfirmButton from '../../../../components/tools/HoldToConfirmButton';

function AccountDeletion() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const accountDelete = async () => {
    try {
      await axios.post('/api/account-deletion', {}, { withCredentials: true });
      navigate('/login');
    } catch (error) {
      console.error('There was an error deleting the account!', error);
    }
  };

  return (
    <div className="account-deletion security-page__danger">
      <p className="security-card__subtitle account-deletion__disclaimer">
        {t('As stated in our')}{' '}
        <Link className="link" to="/gcu">
          {t('GCU')}
        </Link>
        ,{' '}
        {t(
          'only your email will be removed from our database to allow for the anonymization of user data. All other data will remain anonymized and used solely for analytical purposes.'
        )}
      </p>
      <HoldToConfirmButton
        onConfirm={accountDelete}
        holdingLabel={t('Keep holding…')}
        completedLabel={t('Deleting…')}
        data-resource="private.settings.security"
        data-action="delete"
        data-route="/api/account-deletion"
      >
        {t('Delete My Account')}
      </HoldToConfirmButton>
    </div>
  );
}

export default AccountDeletion;
